namespace Areas.Projects {
    "use strict";

    const collaborationAreasGridName = "ProjectCollaborationAreasGrid";

    export function gotoCreateCollaborationArea() {
        Areas.gotoSelected(collaborationAreasGridName , "/CollaborationAreas/Create/Index/");
    }

    export function gotoEditCollaborationArea() {
        Areas.gotoSelected(collaborationAreasGridName , "/CollaborationAreas/Edit/Index/");
    }

    const viewUrl = "/CollaborationAreas/View/Index/";

    export function gotoViewCollaborationArea() {
        Areas.gotoSelected(collaborationAreasGridName , viewUrl);
    }

    export function viewLinkCollaborationArea(cellElement, cellInfo) {
         buildCellContent(cellElement, () => { return cellInfo.data.collaborationAreaId; },
            `<a href= '${viewUrl}{placeholder}'>View</a>`);
    }

}